import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import { Button, Container, SvgIcon } from '@gik/ui';
import { translationKeys as appTranslationKeys } from '@gik/i18n/en/app';
import Link from '@/components/Link';
import routes from '@gik/core/routes';

export const SamplePageBannerBlockName = 'sample-page-banner';

export default function SamplePageBanner(): React.ReactElement {
  const bem = bemBlock(SamplePageBannerBlockName);
  const { t } = useTranslation();

  return (
    <div className={bem()}>
      <Container className={bem('container')}>
        <Link href={routes.tipsAndSamplePages}>
          <Button variant="white" size="sm" circle>
            <SvgIcon name="ArrowLeftOutline" size="sm" />
          </Button>
        </Link>
        <main>
          <span className={bem('title')}>{t(translationKeys.SamplePageTitle)}</span>
          <Link href={routes.create}>
            <Button variant="white" pill size="sm" className="gik-hidden-sm">
              {t(appTranslationKeys.createPage)}
            </Button>
          </Link>
        </main>
      </Container>
    </div>
  );
}
